import Product from './product.factory'
import ProductListService from './product-list.service'

const module = angular.module('ac.repositories.product', [])

module.factory('Product', Product).service('ProductListService', ProductListService)

export default module.name
